import {Component, HostListener, Input, ViewChild} from '@angular/core';
import {BackendService, Host} from "../../../../common";

@Component({
  selector: 'app-footer',
  standalone: false,
  template: `
    <footer class="container">
      <div class="row flex-nowrap">
        <div class="col">
          <button class="btn btn-link" (click)="show('imprint')" i18n>Imprint</button>
        </div>
        <div class="col">
          <button class="btn btn-link" (click)="show('agb')" *ngIf="host.show_footer_terms" i18n>Terms</button>
        </div>
        <div class="col">
          <button class="btn btn-link" (click)="show('privacy')" i18n>Privacy</button>
        </div>
      </div>
    </footer>
    <!--<ng-template #content let-modal>-->
    <drawer [open]="openDrawer" [title]="modalTitle" (close)="onDrawerClosed()">
      <div [innerHTML]="modalContent"></div>
    </drawer>
    <!--</ng-template>-->
  `
})

export class AppFooter {
  @Input() host: Host;
  @ViewChild('content') content;

  modalTitle: string = '';
  modalContent: string = '';
  openDrawer: boolean = false;

  constructor(private backendService: BackendService) {}

  @HostListener('window:hashchange')
  hashChangeHandler() {
    if (location.hash.startsWith('#p-')) {
      this.show(location.hash.substr(3));
    } else {
      this.openDrawer = false;
    }
  }

  show(page: string) {
    this.backendService.getPage(page).toPromise().then((result) => {
      this.modalTitle = result.title;
      this.modalContent= result.content;
      this.openDrawer = true;
      history.pushState(null, result.title ,'#p-' + page);
    })
  }

  onDrawerClosed() {
    this.openDrawer = false;
    history.pushState(null, '' ,'#');
  }
}
